import * as React from 'react';
import  { withStyles, WithStyles } from '@mui/styles';
import AppView from "~common/components/app-view/index"

const styles = {
}

interface Props extends React.HTMLProps<HTMLDivElement>{
  history: any
};

type State = {
  drawerOpen?:any;
};

class NotAuthorizedView extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
  constructor(props:Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {}; 
  }

  UNSAFE_componentWillReceiveProps(newProps:Props & WithStyles<keyof typeof styles>){
    this.setState({drawerOpen: newProps.open})
  }


  render () {

    // const { classes } = this.props

    return (
      <AppView history={this.props.history}>
        <div>Not Authorized</div>
      </AppView>
    );
  }
}

export default withStyles(styles)(NotAuthorizedView);

